// signals that a new page have been visited (each route is a new page)
export const TRACK_PAGE_VISIT = 'TRACK_PAGE_VISIT';
export const TRACK_CART_VIEWED = 'TRACK_CART_VIEWED';
export const TRACK_HEAP_EVENT = 'TRACK_HEAP_EVENT';
export const TRACK_GTM_EVENT = 'TRACK_GTM_EVENT';
export const TRACK_PAYMENT_STEP = 'TRACK_PAYMENT_STEP';
export const TRACK_BREADCRUMB = 'TRACK_BREADCRUMB';
export const TRACK_PRESELECT = 'TRACK_PRESELECT';
export const TRACK_SEGMENT_EVENT = 'TRACK_SEGMENT_EVENT';

export const trackGtmEvent = (event, payload = {}) => ({
  type: TRACK_GTM_EVENT,
  payload: { event, ...payload },
});

export const trackHeapEvent = (event, payload = {}) => ({
  type: TRACK_HEAP_EVENT,
  event,
  payload,
});

export const trackSegmentEvent = (event, payload = {}) => ({
  type: TRACK_SEGMENT_EVENT,
  event,
  payload,
});

export const trackEvent = (event, payload = {}) => dispatch => {
  dispatch(trackHeapEvent(event, payload));
  dispatch(trackGtmEvent(event, payload));
};

export const trackPageVisit = pathname => ({ type: TRACK_PAGE_VISIT, pathname });

export const trackCartViewed = () => dispatch => {
  dispatch(trackGtmEvent('Cart Viewed'));
  dispatch({ type: TRACK_CART_VIEWED }); // For heap tracking
  dispatch(trackSegmentEvent('Cart Viewed'));
};

export const trackPaymentStep = step => ({ type: TRACK_PAYMENT_STEP, step });

export const trackBreadcrumb = pathname => ({ type: TRACK_BREADCRUMB, pathname });

export const trackPreselect = ({ productSlug, locationId }) => ({
  type: TRACK_PRESELECT,
  productSlug,
  locationId,
});

export const trackScroll = scroll_depth => dispatch => {
  dispatch(trackHeapEvent('scrollDepth', { scroll_depth }));
  dispatch(trackGtmEvent('scrollDepth', { scroll_depth }));
};

export const trackHover = payload => dispatch => dispatch(trackHeapEvent('hover', payload));

export const trackSignup = payload => dispatch => {
  dispatch(trackGtmEvent('Account Created', payload));
  dispatch(trackHeapEvent('Account Created', payload));
  dispatch(trackSegmentEvent('Account Created', payload));
};
export const trackConsultationStart = () => dispatch => {
  dispatch(trackGtmEvent('Consultation Started'));
  dispatch(trackHeapEvent('Consultation Started'));
};
export const trackConsultationFinish = () => dispatch => {
  dispatch(trackGtmEvent('Consultation Completed'));
  dispatch(trackHeapEvent('Consultation Completed'));
};

export const trackPurchaseCompleted = payload => dispatch => {
  dispatch(trackGtmEvent('Purchase Completed', payload));
  dispatch(trackHeapEvent('Purchase Completed', payload));
};
export const trackFirstOrder = orderPubkey => dispatch => {
  dispatch(trackGtmEvent('First Order Placed', { orderPubkey }));
  dispatch(trackHeapEvent('First Order Placed', { orderPubkey }));
  dispatch(trackSegmentEvent('First Order Placed'), { orderPubkey });
};

export const trackGiftPurchase = () => dispatch => {
  dispatch(trackGtmEvent('Gift Purchased'));
  dispatch(trackHeapEvent('Gift Purchased'));
};

export const trackReferralSent = network => dispatch => {
  dispatch(trackGtmEvent('Referral Sent', { network }));
  dispatch(trackHeapEvent('Referral Sent', { network }));
};

export const trackFeedbackConfirmationViewed = payload => dispatch => {
  dispatch(trackGtmEvent('Feedback Confirmation Viewed', payload));
  dispatch(trackHeapEvent('Feedback Confirmation Viewed', payload));
};

export const trackReviewAndRefineAccountViewed = payload => dispatch => {
  dispatch(trackGtmEvent('Review & Refine Account Viewed', payload));
  dispatch(trackHeapEvent('Review & Refine Account Viewed', payload));
};

export const trackReviewAndRefineStarted = payload => dispatch => {
  dispatch(trackGtmEvent('Review and Refine Started', payload));
  dispatch(trackHeapEvent('Review and Refine Started', payload));
};

export const trackReviewAndRefineCompleted = payload => dispatch => {
  dispatch(trackGtmEvent('Review and Refine Completed', payload));
  dispatch(trackHeapEvent('Review and Refine Completed', payload));
};

export const trackMembershipModalViewed = () => dispatch => {
  dispatch(trackGtmEvent('Membership modal viewed'));
  dispatch(trackHeapEvent('Membership modal viewed'));
};

export const trackSubscriptionCancelled = payload => dispatch => {
  dispatch(trackGtmEvent('Subscription Cancelled', payload));
  dispatch(trackHeapEvent('Subscription Cancelled', payload));
  dispatch(trackSegmentEvent('Subscription Cancelled', payload));
};

export const trackSubscriptionSnoozed = payload => dispatch => {
  dispatch(trackGtmEvent('Subscription Snoozed', payload));
  dispatch(trackHeapEvent('Subscription Snoozed', payload));
};

const trackSubscriptionStarted = ({ location, payload }) => dispatch => {
  dispatch(trackGtmEvent('Subscription Started', { location, ...payload }));
  dispatch(trackHeapEvent('Subscription Started', { location, ...payload }));
  dispatch(trackSegmentEvent('Subscription Started', { location, ...payload }));
};

export const trackSubscriptionStartedFromCart = payload =>
  trackSubscriptionStarted({ location: 'cart', payload });

export const trackSubscriptionStartedFromAccount = payload =>
  trackSubscriptionStarted({ location: 'account', payload });

export const trackSubscriptionUpdated = payload => dispatch => {
  dispatch(trackGtmEvent('Subscription Updated', payload));
  dispatch(trackHeapEvent('Subscription Updated', payload));
};

export const trackFragranceUpdated = payload => dispatch => {
  dispatch(trackGtmEvent('Fragrance Updated', payload));
  dispatch(trackHeapEvent('Fragrance Updated', payload));
};

export const trackPostPurchaseSurveyCompleted = postPurchaseSurveyEvent => dispatch => {
  dispatch(trackGtmEvent('Post Purchase Survey Completed', postPurchaseSurveyEvent));
  dispatch(trackHeapEvent('Post Purchase Survey Completed', postPurchaseSurveyEvent));
};

export const trackContactFormSubmitted = payload => dispatch => {
  dispatch(trackGtmEvent('Contact Form Submitted', payload));
  dispatch(trackHeapEvent('Contact Form Submitted', payload));
};

export const trackIngredientsSliderPrescriptionViewed = slideNumber => dispatch => {
  dispatch(trackGtmEvent(`Your Formula - Ingredients slide ${slideNumber} viewed`));
  dispatch(trackHeapEvent(`Your Formula - Ingredients slide ${slideNumber} viewed`));
};

export const trackGoalSelectorPrescriptionChanged = goal => dispatch => {
  dispatch(trackGtmEvent(`Scoring slides viewed - ${goal}`));
  dispatch(trackHeapEvent(`Scoring slides viewed - ${goal}`));
};

export const trackUtmSource = payload => dispatch => {
  dispatch(trackSegmentEvent('UTM Source', payload));
};

export const trackRoutineSliderPrescriptionScroll = routineName => dispatch => {
  dispatch(trackGtmEvent(`Routine - ${routineName} Carousel Scrolled`));
  dispatch(trackHeapEvent(`Routine - ${routineName} Carousel Scrolled`));
};
export const trackRoutinePrescriptionLoaded = (event, payload) => dispatch => {
  dispatch(trackGtmEvent(event, payload));
  dispatch(trackHeapEvent(event, payload));
};

export const trackRoutineMiniPDPViewed = payload => dispatch => {
  dispatch(trackGtmEvent('Your Routine - Mini PDP Viewed', payload));
  dispatch(trackHeapEvent('Your Routine - Mini PDP Viewed', payload));
};
